<template>
  <div class="m-auto m-1230">
    <div class="row align-items-center">
      <div class="col-lg-6 d-none d-lg-block">
        <img
          src="@/assets/images/EEdT_Thumbnail.png"
          class="rounded-3"
          alt="login"
        />
      </div>
      <div class="col-lg-6">
        <div class="mw-480 ms-lg-auto">
          <div class="d-inline-block mb-4">
            <img
              src="/favicon-32x32.png"
              class="rounded-3 for-light-logo"
              alt="login"
            />
            <img
              src="@/assets/images/white-logo.svg"
              class="rounded-3 for-dark-logo"
              alt="login"
            />
          </div>
          <form @submit.prevent="validateForm">
            <div class="form-group mb-4">
              <label class="label text-secondary">Correo electrónico</label>
              <input
                type="email"
                class="form-control h-45"
                placeholder="Ingresar el username"
                v-model="userLogin.username"
                @input="clearError('username')"
              />
              <div class="input-error">{{ errors.username }}</div>
            </div>
            <div class="form-group mb-4">
              <label class="label text-secondary">Contraseña</label>
              <input
                autocomplete="off"
                type="password"
                class="form-control h-45"
                v-model="userLogin.password"
                @input="clearError('password')"
                placeholder="Ingrese la contraseña"
              />
              <div class="input-error">{{ errors.password }}</div>
            </div>
            <div class="form-group mb-4">
              <button
                type="submit"
                :disabled="isLoading"
                class="btn btn-primary fw-medium py-2 px-3 w-100"
              >
                <div
                  class="d-flex align-items-center justify-content-center py-1"
                >
                  <i
                    v-if="!isLoading"
                    class="material-symbols-outlined text-white fs-20 me-2"
                  >
                    login
                  </i>
                  <span v-if="!isLoading">Ingresar</span>
                  <span
                    class="spinner-border spinner-border-sm me-2"
                    aria-hidden="true"
                    v-if="isLoading"
                  ></span>
                  <span role="status" v-if="isLoading">Procesando...</span>
                </div>
              </button>
              <div class="mt-1" >
                <b-link class="link blue" @click="getModalRecover"
                  ><span>¿Olvidaste tu contraseña?</span></b-link
                >
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal -->
  <div
    id="mdlRecover"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="mdlRecoverLabel"
    aria-hidden="true"
    size="large"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="mdlRecoverLabel">
            Recuperar Contraseña
          </h1>
        </div>
        <div class="modal-body">
          <form @submit.prevent="validateFormRecovery">
            <div class="row">
              <div class="col-lg-6 col-sm-6">
                <div class="form-group mb-4">
                  <label class="label text-secondary strong"
                    >Correo Electrónico</label
                  >
                  <input
                    type="text"
                    class="form-control h-45"
                    placeholder="Ingresar el username"
                    v-model="userRecover.username"
                    @input="clearError('username')"
                  />
                  <div class="input-error">{{ errors.username }}</div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-6">
                <div class="form-group mb-4"></div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="submit"
                :disabled="isLoadingRecover"
                class="btn btn-primary"
              >
                <div class="d-flex align-items-center justify-content-center">
                  <span v-if="!isLoadingRecover">Confirmar</span>
                  <span
                    class="spinner-border spinner-border-sm me-2"
                    aria-hidden="true"
                    v-if="isLoadingRecover"
                  ></span>
                  <span role="status" v-if="isLoadingRecover"
                    >Procesando...</span
                  >
                </div>
              </button>
              <button
                type="button"
                class="btn btn-danger text-white"
                data-bs-dismiss="modal"
              >
                Cerrar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { userLoginSchema } from "@/schemas/userLoginSchema";
import { userRecoveryPassword } from "@/schemas/userRecoveryPassword";

import { useRouter } from "vue-router";
import { useToast } from "vue-toastification";
import api from "@/services/api";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Login",
  setup() {
    const toast = useToast();
    const router = useRouter();
    const isLoading = ref(false);
    const isLoadingRecover = ref(false);

    const userLogin = ref({
      username: null,
      password: null,
    });
    const userRecover = ref({
      username: null,
    });
    const errors = ref<Record<string, string>>({});

    const validateForm = async () => {
      try {
        errors.value = {};
        await userLoginSchema.validate(userLogin.value, { abortEarly: false });
        isLoading.value = true;

        await login();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " + err);
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false;
      }
    };

    const clearError = (field: string) => {
      errors.value[field] = "";
    };
    const modalRecover = ref<any>(null);
    const login = async () => {
      try {
        const response: any = await api.post(
          `/auth/admin/login`,
          userLogin.value
        );

        if (response.data != null) {
          var datos = response.data;
          localStorage.setItem("authToken", JSON.stringify(datos.authToken));
          localStorage.setItem("user", JSON.stringify(datos.user));
          localStorage.setItem(
            "forcePasswordChange",
            datos.forcePasswordChange
          );

          if (datos.forcePasswordChange) {
            router.push({ name: "ResetPasswordPage" });
          } else {
            router.push({ name: "UsersPage" });
          }
        }
      } catch (ex: any) {
        var errorMsg = "";
        if (ex.response?.data) {
          errorMsg = ex.response?.data;
        } else {
          errorMsg = "Error interno";
        }
        toast.error(errorMsg, {
          timeout: 2000,
        });
        console.error(ex);
      }
    };
    const getModalRecover = async () => {
      const modalElement = document.getElementById("mdlRecover");

      if (modalElement) {
        modalRecover.value = new window.bootstrap.Modal(modalElement);
        modalRecover.value.show();
      }
    };
    const validateFormRecovery = async () => {
      try {
        errors.value = {};
        await userRecoveryPassword.validate(userRecover.value, {
          abortEarly: false,
        });
        isLoadingRecover.value = true;

        await recoveryPassword();
        isLoadingRecover.value = false;
      } catch (err: any) {
        console.log("err: " + err);
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoadingRecover.value = false;
      }
    };
    const recoveryPassword = async () => {
      try {
        const response = await api.get(
          `/user/validate-recovery-password?username=${userRecover.value.username}`
        );
        if (response.data > 0) {
          toast.success("Se envió correctamente", {
            timeout: 2000,
          });
         userRecover.value.username =null;
        }
      } catch (ex: any) {
        var errorMsg = "";
        if (ex.response?.data) {
          errorMsg = ex.response?.data;
        } else {
          errorMsg = "Error interno";
        }
        toast.error(errorMsg, {
          timeout: 2000,
        });
        console.error(ex);
      }
    };
    return {
      validateForm,
      validateFormRecovery,
      clearError,
      userLogin,
      userRecover,
      recoveryPassword,
      errors,
      isLoading,
      isLoadingRecover,
      getModalRecover,
    };
  },
});
</script>
